import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { setNewsByExpertData } from '../../../../../../reducer';
import './index.scss';

class ExpandNews extends React.Component {
  constructor(props) {
    super(props);
    const { index } = props;
    this.state = {
      isExpand: index === 0,
    };
  }

  handleOnclick = () => {
    this.setState(({ isExpand }) => {
      return { isExpand: isExpand ? false : true };
    });
  };

  onClickNew = newsId => {
    const { setNewsByExpertData } = this.props;
    setNewsByExpertData('newId', newsId);
  };

  render() {
    const { timeStamp = 'dateTime', listNews = [] } = this.props;
    const { isExpand } = this.state;
    return (
      <li
        className={`${isExpand ? 'active' : ''}`}
        onClick={this.handleOnclick}
      >
        <p className="">{timeStamp}</p>
        {isExpand && (
          <>
            {listNews.map((data, index) => {
              return (
                <div
                  key={index}
                  className="d-flex"
                  onClick={() => this.onClickNew(data.newsId)}
                  style={{ whiteSpace: 'nowrap' }}
                >
                  <div className="mr-3">
                    {moment(data.publicDate).format('DD/MM')}
                  </div>
                  <div>{data.newsTitle}</div>
                </div>
              );
            })}
          </>
        )}
      </li>
    );
  }
}

const mapDispatchToProps = {
  setNewsByExpertData,
};

export default connect(
  null,
  mapDispatchToProps,
)(ExpandNews);
